/**
 * हिन्दी — Hindi translations for the Farmsons marketing site.
 * `data` overrides content from src/lib/data.js, keyed by slug / name / index.
 * Cultivar, rootstock and series names stay in Latin script — they are the
 * identifiers used in horticultural trade.
 */
export default {
  common: {
    quote: "कोट का अनुरोध करें",
    downloadProfile: "कंपनी प्रोफ़ाइल डाउनलोड करें",
  },
  nav: {
    ventures: "हमारे क्षेत्र",
    fruit: "फल व्यापार",
    rootstock: "रूटस्टॉक आयात व वितरण",
    mango: "आम निर्यात",
    story: "हमारी कहानी",
    sourcing: "सोर्सिंग",
    partners: "साझेदार",
    quality: "गुणवत्ता",
    insights: "जानकारियाँ",
    contact: "संपर्क",
    language: "भाषा",
  },
  hero: {
    lines: ["बाग से", "निर्यात तक —", "कृषि उपज के भविष्य", "का व्यापार"],
    sub: "फ़ार्मसंस हिमाचल, कश्मीर और भारत की आम-पेटियों के किसानों को सीधे अंतरराष्ट्रीय खरीदारों से जोड़ती है — एक आधुनिक ट्रेडिंग कंपनी में संरचना, गुणवत्ता मानक और किसानों से सच्चे रिश्ते लाती है।",
    partner: "हमसे साझेदारी करें",
  },
  marquee: {
    items: ["सेब", "आम", "रूटस्टॉक", "वैश्विक आयात", "निर्यात-ग्रेड", "हिमाचल", "कश्मीर", "मालदा"],
  },
  ventures: {
    overline: "हम क्या करते हैं",
    heading: "तीन क्षेत्र। एक ही परिचालन अनुशासन।",
    para: "एक दोहराने योग्य मॉडल जो बिना पुनः डिज़ाइन किए नए क्षेत्र जोड़ने के लिए बना है — आज व्यापार से, आगे आयात और निर्यात तक।",
    explore: "जानें",
  },
  cine: { l1: "बाग से", l2pre: "", l2accent: "निर्यात तक." },
  partnersGrid: {
    overline: "साझेदार",
    heading: "आपूर्ति शृंखला भर के साझेदारों का भरोसा।",
    visit: "साइट देखें",
  },
  home: {
    storyOverline: "हमारी कहानी",
    storyHeading: "पीढ़ियों पुरानी जड़ें, आधुनिक परिचालन कुशलता से मिलती हैं।",
    storyLink: "हमारी पूरी कहानी पढ़ें और संस्थापक से मिलें",
    ctaHeading: "आइए एक व्यापारिक साझेदारी बनाएं।",
  },
  about: {
    overline: "हमारी कहानी",
    title: "पीढ़ियों पुरानी जड़ें, आधुनिक परिचालन कुशलता से मिलती हैं।",
    lede: "कोलकाता में जड़ें जमाए एक ट्रेडिंग हाउस, अपने अगले अध्याय में कदम रखते हुए — संरचना, गुणवत्ता मानक और किसानों से सीधे रिश्तों को एक कंपनी में लाता है।",
    founderOverline: "संस्थापक",
    founderHeading: "एक अलग पृष्ठभूमि, पारंपरिक व्यापार में।",
    exploreLink: "जानें हम क्या करते हैं — फल व्यापार, रूटस्टॉक और आम निर्यात",
  },
  vertical: {
    overline: "हम क्या करते हैं",
    ctaHeading: "{venture} में रुचि है? आइए बात करें।",
    exploreOthers: "अन्य क्षेत्र देखें:",
    sourcingLink: "सोर्सिंग और क्षेत्र",
    appleOverline: "सेब की किस्में",
    appleTitle: "हिमाचल प्रदेश और कश्मीर के सेब",
    appleIntro: "हमारी वास्तविक सोर्स की गई किस्मों पर आधारित — हिमाचल की पहचान रॉयल डिलिशस से लेकर खट्टी हरी ग्रैनी स्मिथ और ऊँचाई वाले किन्नौर सेब तक।",
    mangoOverline: "आम की किस्में",
    mangoTitle: "दक्षिण व पूर्व भारत के आम",
    mangoIntro: "प्रीमियम अल्फांसो और GI-टैग केसर व बंगनपल्ली से लेकर बंगाल की मालदा पेटी के सुगंधित हिमसागर और लंगड़ा तक।",
  },
  sourcing: {
    overline: "सोर्सिंग और क्षेत्र",
    title: "हिमालय की तराई से गंगा डेल्टा तक — और आठ आयात स्रोत।",
    lede: "हर क्षेत्र जहाँ से हम सोर्स करते हैं, किसी वजह से चुना गया है। किसान रिश्तों और व्यापार स्रोतों के हमारे वैश्विक नेटवर्क को जानने के लिए मानचित्र पर किसी भी बिंदु पर होवर करें।",
    legendHQ: "कोलकाता मुख्यालय",
    legendOrigins: "सोर्सिंग व व्यापार स्रोत — जानने के लिए किसी बिंदु पर होवर करें।",
    importOverline: "सेब आयात स्रोत",
    tradeLink: "देखें हम फलों का व्यापार और आयात कैसे करते हैं",
  },
  map: { title: "वैश्विक सोर्सिंग नेटवर्क" },
  partnersPage: {
    overline: "साझेदार",
    title: "आपूर्ति शृंखला भर के साझेदारों का भरोसा।",
    lede: "बाग की आवश्यकताओं से लेकर वितरण और निर्यात लॉजिस्टिक्स तक, फ़ार्मसंस हर चरण में भरोसेमंद डिलीवरी के लिए स्थापित नामों के साथ सहयोग करती है।",
  },
  qualityPage: {
    overline: "गुणवत्ता और प्रमाणन",
    title: "सीमा-पार भरोसे के लिए बने मानक।",
    lede: "अंतरराष्ट्रीय खरीदार किसी ट्रेडिंग साझेदार का मूल्यांकन निरंतरता पर करते हैं। चार स्तंभ फ़ार्मसंस की हर खेप की नींव हैं — नाम वाले किसान से दूर के बंदरगाह तक।",
  },
  qualityGrid: {
    overline: "यह क्यों मायने रखता है",
    para: "अंतरराष्ट्रीय खरीदार किसी ट्रेडिंग साझेदार का मूल्यांकन निरंतरता पर करते हैं। हमारा गुणवत्ता ढांचा पहले दिन से आयात विनिर्देशों, अनुपालन और ट्रेसेबिलिटी को पूरा करने के लिए संरचित है।",
    badge: "निर्यात-तैयार लॉजिस्टिक्स",
  },
  insights: {
    overline: "जानकारियाँ",
    title: "बाग से बंदरगाह तक की बातें।",
    lede: "भारत के फल व्यापार पर व्यावहारिक दृष्टिकोण — खरीदारों और किसानों के लिए सीज़न पूर्वानुमान, कृषि-विज्ञान और निर्यात विशेषज्ञता।",
    read: "पढ़ें",
  },
  article: {
    back: "सभी जानकारियाँ",
    cta: "फ़ार्मसंस के साथ सोर्सिंग या साझेदारी करना चाहते हैं?",
  },
  contact: {
    overline: "संपर्क / कोट का अनुरोध",
    title: "आइए एक व्यापारिक साझेदारी बनाएं।",
    para: "चाहे आप अंतरराष्ट्रीय आयातक हों, बाग मालिक हों, या आपूर्ति साझेदार — हमें बताएं आपको क्या चाहिए और हमारी टीम सीधे जवाब देगी।",
    address: "कोलकाता, पश्चिम बंगाल, भारत",
    waPreface: "जल्दी बात करनी है? WhatsApp पर संपर्क करें।",
    profileTitle: "कंपनी प्रोफ़ाइल",
    profileDesc: "फ़ार्मसंस का एक-पृष्ठ परिचय — हमारे व्यावसायिक क्षेत्र, सोर्सिंग क्षेत्र और गुणवत्ता मानक।",
  },
  form: {
    name: "पूरा नाम",
    email: "ईमेल",
    company: "कंपनी",
    country: "देश",
    interest: "उत्पाद रुचि",
    message: "संदेश",
    namePh: "आपका नाम",
    emailPh: "you@company.com",
    companyPh: "कंपनी का नाम",
    countryPh: "देश",
    interestPrompt: "रुचि चुनें",
    messagePh: "अपनी आवश्यकता, मात्रा और समय-सीमा बताएं।",
    submit: "पूछताछ भेजें",
    sending: "भेजा जा रहा है...",
    incomplete: "कृपया सभी फ़ील्ड भरें।",
    error: "कुछ गड़बड़ हुई। कृपया पुनः प्रयास करें।",
    tooMany: "बहुत अधिक अनुरोध। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
    successTitle: "पूछताछ मिल गई",
    successBody: "धन्यवाद। फ़ार्मसंस टीम का सदस्य शीघ्र ही आपसे संपर्क करेगा।",
    successAgain: "एक और पूछताछ भेजें",
    successToast: "पूछताछ भेज दी गई — हमारी टीम संपर्क करेगी।",
  },
  wa: {
    chat: "WhatsApp पर बात करें",
    aria: "WhatsApp पर फ़ार्मसंस से बात करें",
    message: "नमस्ते फ़ार्मसंस, मैं उपज व्यापार संबंधी पूछताछ पर चर्चा करना चाहूँगा।",
  },
  rootstockGuide: {
    overline: "रूटस्टॉक किस्म गाइड",
    title: "अपने बाग के लिए सही रूटस्टॉक चुनें।",
    intro: "रूटस्टॉक का चुनाव तय करता है पेड़ का आकार, बाग कितनी जल्दी फल देगा, रोग प्रतिरोध, और स्थानीय मिट्टी व जलवायु के लिए अनुरूपता। फ़ार्मसंस हिमाचल और कश्मीर के किसानों को सही स्थान के लिए सही रूटस्टॉक चुनने में मदद करती है — केवल आपूर्ति नहीं। नीचे शृंखला या शक्ति वर्ग से छाँटें।",
    series: "शृंखला",
    vigor: "शक्ति",
    all: "सभी",
    bestFit: "सर्वोत्तम उपयोग",
    noMatch: "इस संयोजन से कोई रूटस्टॉक नहीं मिला।",
  },
  unsub: {
    title: "सदस्यता रद्द करें",
    processing: "आपका अनुरोध संसाधित हो रहा है…",
    success: "सदस्यता रद्द हो गई",
    successBody: "आपको हमारे न्यूज़लेटर से हटा दिया गया है। आपको जाते देख खेद है।",
    invalid: "अमान्य लिंक",
    invalidBody: "यह सदस्यता-रद्द लिंक अमान्य है या पहले ही उपयोग हो चुका है।",
    home: "होम पर वापस जाएं",
  },
  footer: {
    blurb: "बाग से निर्यात तक — एक पंजीकृत कृषि उपज ट्रेडिंग कंपनी जो किसानों और अंतरराष्ट्रीय खरीदारों के बीच आधुनिक ढांचा बना रही है। स्थापना 1985, कोलकाता।",
    explore: "देखें",
    office: "कार्यालय",
    ourStory: "हमारी कहानी",
    city: "कोलकाता, पश्चिम बंगाल",
    country: "भारत",
    rights: "सर्वाधिकार सुरक्षित।",
    tagline: "कृषि उपज के भविष्य का व्यापार।",
    newsTitle: "फ़ार्मसंस न्यूज़लेटर",
    newsDesc: "फल व्यापार की मौसमी जानकारियाँ, सीधे आपके इनबॉक्स में।",
    newsPlaceholder: "आपका ईमेल पता",
    newsButton: "सदस्यता लें",
    newsSuccess: "सदस्यता मिल गई — फ़ार्मसंस न्यूज़लेटर में स्वागत है।",
    newsError: "सदस्यता नहीं हो सकी। पुनः प्रयास करें।",
  },
  data: {
    ventures: {
      "fruit-trading": {
        status: "अभी सक्रिय",
        title: "फल व्यापार",
        tagline: "सेब और आम की खरीद, संरचित आयात, और कमीशन-आधारित वितरण — कोलकाता में स्थित।",
        tags: ["सेब", "आम", "आयात", "वितरण"],
        intro: "फल व्यापार फ़ार्मसंस का सक्रिय, राजस्व देने वाला क्षेत्र है। हम सीधे किसानों से खरीदते हैं, निर्यात-ग्रेड गुणवत्ता नियंत्रण लागू करते हैं, और पारदर्शी, रिश्तों पर आधारित आपूर्ति शृंखला के माध्यम से घरेलू और अंतरराष्ट्रीय खरीदारों तक फल पहुँचाते हैं।",
        sections: [
          { heading: "घरेलू सेब खरीद", body: "हम हिमाचल प्रदेश (शिमला, किन्नौर, कुल्लू) और कश्मीर (शोपियां, सोपोर) के बागों से सीधे सेब खरीदते हैं। खेत के द्वार से खरीद — अज्ञात मंडी लॉट से नहीं — किसानों को बेहतर दाम और खरीदारों को पूरी ट्रेसेबिलिटी देती है।" },
          { heading: "दक्षिण व पूर्व भारत में आम सोर्सिंग", body: "सीज़न में हम गंगा डेल्टा में पश्चिम बंगाल की मालदा और मुर्शिदाबाद पेटी से, तथा आंध्र प्रदेश और कर्नाटक के स्थापित बागों से आम खरीदते हैं, हर खरीदार की ज़रूरत के अनुसार किस्म और ग्रेड मिलाते हैं।" },
          { heading: "संरचित सेब आयात", body: "फ़ार्मसंस आठ देशों — तुर्की, ईरान, इटली, पोलैंड, चिली, दक्षिण अफ्रीका, न्यूज़ीलैंड और संयुक्त राज्य अमेरिका — से भारत में सेब आयात व्यापार में भाग लेती है, सोर्सिंग, दस्तावेज़ीकरण और कोल्ड-चेन का प्रबंधन करती है।" },
          { heading: "कमीशन-आधारित वितरण", body: "कोलकाता में स्थित कमीशन-आधारित वितरण साझेदारियों के माध्यम से, हम खेपों को थोक और खुदरा विक्रेताओं के विश्वसनीय नेटवर्क से जोड़ते हैं, आपूर्तिकर्ताओं को भरोसेमंद बिक्री और बाज़ार पहुँच देते हैं।" },
        ],
        highlights: {
          title: "एक खेप का सफ़र",
          items: [
            { title: "01 · सोर्स", desc: "नाम वाले किसान रिश्तों से जुड़ी खेत-द्वार खरीद।" },
            { title: "02 · ग्रेड", desc: "विनिर्देश के अनुसार आकार, ब्रिक्स और दोष ग्रेडिंग।" },
            { title: "03 · परिवहन", desc: "बाज़ार या बंदरगाह तक तापमान-नियंत्रित हैंडलिंग।" },
            { title: "04 · भुगतान", desc: "किसानों और खरीदारों के लिए पारदर्शी, समय पर निपटान।" },
          ],
        },
      },
      rootstock: {
        status: "जल्द आ रहा है",
        title: "रूटस्टॉक आयात व वितरण",
        tagline: "प्रमाणित सेब रूटस्टॉक — M9, MM106, M111 — हिमाचल और कश्मीर के हाई-डेंसिटी बागों के लिए।",
        intro: "रूटस्टॉक आयात व वितरण फ़ार्मसंस को एक भरोसेमंद कृषि-इनपुट साझेदार के रूप में स्थापित करता है। हम प्रमाणित क्लोनल सेब रूटस्टॉक आयात करके उन्हें अपने बाग आधुनिक बनाने वाले किसानों तक पहुँचाते हैं — सही स्थान के लिए सही रूटस्टॉक का मिलान करते हुए।",
        sections: [
          { heading: "रूटस्टॉक क्या है — और यह क्यों मायने रखता है", body: "सेब का पेड़ दो पौधों का मेल है: फल देने वाली किस्म (सायन) जो जड़ तंत्र (रूटस्टॉक) पर ग्राफ्ट की जाती है। रूटस्टॉक तय करता है पेड़ कितना बड़ा होगा, कितनी जल्दी फल देगा, और मिट्टी व बीमारियों का सामना कितना अच्छा करेगा। सही रूटस्टॉक चुनना आधुनिक बाग लगाने का सबसे बड़ा निर्णय है।" },
          { heading: "M9 — हाई-डेंसिटी, जल्दी फल", body: "एक बौना रूटस्टॉक जो पेड़ों को छोटा रखता है, जिससे तार-ढांचे पर प्रति हेक्टेयर हज़ारों पेड़ संभव हैं। बाग जल्दी फल देते हैं और काट-छाँट व कटाई आसान होती है — हाई-डेंसिटी बागवानी की नींव।" },
          { heading: "MM106 — संतुलित भरोसेमंद", body: "अर्ध-बौना रूटस्टॉक जो शक्ति, स्थिरता और उपज का मजबूत संतुलन देता है। उन अनेक स्थानों के लिए उपयुक्त जहाँ पूर्ण हाई-डेंसिटी ढांचा अभी स्थापित नहीं है।" },
          { heading: "M111 — कठिन स्थानों के लिए शक्ति", body: "मजबूत, हार्डी रूटस्टॉक जो सूखा और असमान मिट्टी सहता है, सीमांत या पुनः-रोपण भूमि पर मजबूती से स्थिर पेड़ देता है जहाँ बौनी किस्में संघर्ष करेंगी।" },
        ],
        highlights: {
          title: "किसान हमसे क्यों जुड़ते हैं",
          items: [
            { title: "प्रमाणित स्टॉक", desc: "ट्रेस करने योग्य, रोग-जाँचित क्लोनल सामग्री।" },
            { title: "सही सलाह", desc: "स्थान, किस्म और लक्ष्य से मिलान किया रूटस्टॉक।" },
            { title: "हाई-डेंसिटी तैयार", desc: "आधुनिक तार-ढांचा बाग प्रणालियों के लिए सहायता।" },
            { title: "भरोसेमंद आपूर्ति", desc: "संरचित आयात ताकि रोपण का मौसम न छूटे।" },
          ],
        },
      },
      "mango-export": {
        status: "जल्द आ रहा है",
        title: "आम निर्यात",
        tagline: "अल्फांसो, केसर, बंगनपल्ली और तोतापुरी — निर्यात-ग्रेड, UAE, UK, USA और कनाडा तक।",
        intro: "आम निर्यात फ़ार्मसंस की सोर्सिंग ताकत को अंतरराष्ट्रीय बाज़ारों तक बढ़ाता है। ट्रेसेबल सोर्सिंग और निर्यात-ग्रेड मानकों के साथ, हम भारत की प्रीमियम आम किस्मों को विदेश के चुनिंदा खरीदारों तक पहुँचाने के मार्ग बना रहे हैं।",
        sections: [
          { heading: "अल्फांसो — अग्रणी", body: "केसरिया गूदे, सुगंध और समृद्ध स्वाद के लिए प्रसिद्ध, अल्फांसो भारत का सबसे प्रसिद्ध आम है और खाड़ी, UK और उत्तरी अमेरिका में प्रीमियम निर्यात मांग की आधारशिला।" },
          { heading: "केसर — सुगंधित और चमकीला", body: "अपने चमकीले नारंगी गूदे और विशिष्ट खुशबू के लिए जाना जाने वाला केसर लंबी दूरी अच्छी तरह सहता है और दक्षिण एशियाई प्रवासी बाज़ारों में इसका वफ़ादार समर्थक वर्ग है।" },
          { heading: "बंगनपल्ली और तोतापुरी — दक्षिण भारतीय मात्रा", body: "बंगनपल्ली बड़ा, रेशे रहित, मीठा फल देता है जिसका शेल्फ-लाइफ मजबूत है, जबकि तोतापुरी खट्टी, प्रोसेसिंग-अनुकूल मात्रा जोड़ती है — दोनों मिलकर निर्यात टोकरी को एक सीज़न से आगे बढ़ाते हैं।" },
        ],
        highlights: {
          title: "लक्ष्य बाज़ार",
          items: [
            { title: "UAE", desc: "प्रीमियम भारतीय आम के लिए स्थापित खाड़ी मांग।" },
            { title: "यूनाइटेड किंगडम", desc: "प्रवासी और स्पेशलिटी-रिटेल की मजबूत मांग।" },
            { title: "USA", desc: "निर्यात प्रोटोकॉल के तहत बढ़ता प्रीमियम बाज़ार।" },
            { title: "कनाडा", desc: "ट्रेसेबल, ग्रेडेड फलों के लिए बढ़ती रुचि।" },
          ],
        },
      },
    },
    pillars: [
      { title: "1985 से विरासत", body: "फ़ार्मसंस कृषि व्यापार में लगभग चार दशकों पुरानी पारिवारिक विरासत लेती है — हिमाचल प्रदेश, कश्मीर और दक्षिण व पूर्व भारत की आम-पेटियों में किसानों से सच्चे रिश्तों में जड़ें जमाए हुए।" },
      { title: "जो खाई हम भर रहे हैं", body: "भारत का उपज व्यापार अनौपचारिक रिश्तों और स्थानीय मंडियों पर चलता रहा है, जिसमें किसानों को अंतरराष्ट्रीय खरीदारों से जोड़ने वाला आधुनिक ढांचा न के बराबर है। फ़ार्मसंस वही परत बना रही है — फल व्यापार से रूटस्टॉक वितरण और आम निर्यात तक।" },
      { title: "जड़ें और अनुशासन का संगम", body: "संरचना, गुणवत्ता मानक और किसानों से सीधे रिश्ते — सब एक ही कंपनी में। पीढ़ियों पुरानी जड़ों और आधुनिक परिचालन अनुशासन का मिलन — कोलकाता का एक ट्रेडिंग हाउस अपने अगले अध्याय में प्रवेश कर रहा है।" },
    ],
    founder: {
      name: "ज़ाहिद शमीम",
      role: "संस्थापक",
      tags: ["जादवपुर विश्वविद्यालय", "UCLA एंडरसन से MBA", "पूर्व-Visa", "पूर्व-PropTech"],
      paras: [
        "फ़ार्मसंस को अगले चरण में ले जा रहे हैं इसके संस्थापक ज़ाहिद शमीम — जादवपुर विश्वविद्यालय से कंप्यूटर साइंस इंजीनियरिंग स्नातक और UCLA एंडरसन से MBA, जिनका Visa और एक PropTech कंपनी में उत्पाद व प्रौद्योगिकी नेतृत्व का अनुभव रहा है।",
        "वे अब फ़ार्मसंस में रणनीति, परिचालन, उत्पाद और गो-टू-मार्केट का नेतृत्व करते हैं — कोलकाता स्थित कृषि ट्रेडिंग कंपनी पर वैश्विक व्यावसायिक अनुशासन लागू करते हुए। कहानी है पीढ़ियों पुरानी जड़ों और आधुनिक परिचालन कुशलता की: कोलकाता में जड़ें जमाई शिक्षा, वैश्विक व्यावसायिक करियर, और पारिवारिक व्यवसाय को अगले अध्याय में ले जाने की वापसी।",
        "उनकी दृष्टि है रिश्तों पर आधारित व्यापार को आधुनिक, व्यावसायिक ढांचे में बदलना — जहाँ किसान नाम से जाने जाने वाले साझेदार हों, गुणवत्ता अंतरराष्ट्रीय विनिर्देशों पर मापी जाए, और दुनिया में कहीं भी खरीदार एक ही जवाबदेह कंपनी के साथ लेन-देन कर सकें। प्रौद्योगिकी, पारदर्शिता और ट्रेसेबिलिटी आज के फल व्यापार से आगे रूटस्टॉक वितरण और आम निर्यात तक की संयोजक कड़ी है।",
      ],
    },
    regions: [
      { name: "हिमाचल प्रदेश", type: "सेब पेटी", note: "शिमला, किन्नौर, कुल्लू और मंडी के ऊँचे बाग।" },
      { name: "कश्मीर", type: "सेब पेटी", note: "शोपियां और सोपोर से प्रीमियम घाटी के सेब।" },
      { name: "मालदा और मुर्शिदाबाद", type: "आम क्षेत्र — पश्चिम बंगाल", note: "सुगंधित आम किस्मों के लिए प्रसिद्ध गंगा डेल्टा पेटी।" },
      { name: "आंध्र और कर्नाटक", type: "आम क्षेत्र — दक्षिण भारत", note: "स्थापित दक्षिणी बागों से बंगनपल्ली और तोतापुरी।" },
    ],
    importOrigins: ["तुर्की", "ईरान", "इटली", "पोलैंड", "चिली", "दक्षिण अफ्रीका", "न्यूज़ीलैंड", "संयुक्त राज्य अमेरिका"],
    mapLabels: ["कोलकाता (मुख्यालय)", "हिमाचल और कश्मीर", "तुर्की", "ईरान", "इटली", "पोलैंड", "संयुक्त राज्य अमेरिका", "चिली", "दक्षिण अफ्रीका", "न्यूज़ीलैंड"],
    quality: [
      { title: "ट्रेसेबल सोर्सिंग", desc: "हर खेप नाम वाले किसान रिश्ते और एक विशिष्ट क्षेत्र से जुड़ी होती है — कभी अज्ञात मंडी लॉट से नहीं। यह ट्रेसेबिलिटी खरीदारों को उत्पत्ति का और हमें गुणवत्ता का भरोसा देती है।" },
      { title: "निर्यात-ग्रेड ग्रेडिंग", desc: "फलों की ग्रेडिंग अंतरराष्ट्रीय खरीदार विनिर्देशों के अनुसार होती है — मापित आकार, ब्रिक्स (शर्करा) माप और दोष जाँच — ताकि जो ऑर्डर किया गया, हर बार वही पहुँचे।" },
      { title: "कोल्ड-चेन अखंडता", desc: "पैकहाउस से बंदरगाह तक तापमान-नियंत्रित हैंडलिंग दृढ़ता, स्वाद और शेल्फ-लाइफ बचाती है, बिगाड़ घटाती है और दूर के खरीदारों को आगमन पर भरोसेमंद, समान स्थिति देती है।" },
      { title: "अनुपालन के लिए तैयार", desc: "दस्तावेज़ीकरण और पादप-स्वास्थ्य प्रक्रियाएँ पहले दिन से सीमा-पार व्यापार के लिए संरचित हैं, ताकि खेप सुचारू रूप से क्लियर हो और खरीदारों को सीमा पर कोई आश्चर्य न मिले।" },
    ],
    interests: ["सेब व्यापार", "आम निर्यात", "सेब आयात", "रूटस्टॉक आपूर्ति", "वितरण साझेदारी", "अन्य"],
    vigor: { Dwarfing: "बौना", "Semi-dwarf": "अर्ध-बौना", "Semi-vigorous": "अर्ध-शक्तिशाली", Vigorous: "शक्तिशाली" },
    varieties: {
      "Royal Delicious": { tag: "हिमाचल · सितंबर चरम", desc: "हिमाचल का पहचान सेब — गहरा लाल, कुरकुरा और मीठा। मुख्यतः कुल्लू, शिमला, किन्नौर और मंडी से।" },
      "Red Delicious": { tag: "हिमाचल · सितंबर", desc: "सबसे पुरानी व्यावसायिक किस्मों में से एक — हल्का स्वाद, गहरी लाल त्वचा पर महीन हरी धारियाँ।" },
      "Golden Delicious": { tag: "जम्मू-कश्मीर · अक्टूबर", desc: "पीली-हरी त्वचा, हल्की शहद जैसी मिठास। जम्मू-कश्मीर में प्रचलित।" },
      "Royal Gala": { tag: "कश्मीर · अगस्त", desc: "हल्का लाल से गुलाबी, मीठा और कुरकुरा — कश्मीर से शुरुआती सीज़न का पसंदीदा।" },
      Fuji: { tag: "हिमाचल की ऊँचाई · अक्टूबर", desc: "बड़ा, सख्त और अत्यंत मीठा, लंबा शेल्फ-लाइफ। हिमाचल के चुनिंदा ऊँचे बागों में उगाया जाता है।" },
      "Granny Smith": { tag: "चुनिंदा क्षेत्र · अक्टूबर", desc: "चमकीला हरा और ताज़ा खट्टा — चुनिंदा क्षेत्रों में उगाई जाने वाली सख्त, बहुमुखी किस्म।" },
      "Kinnaur Apple": { tag: "किन्नौर · ~9000 फीट", desc: "लगभग 9,000 फीट की ऊँचाई पर उगाया जाता है — गहरा लाल और अपने असाधारण क्रंच के लिए प्रसिद्ध।" },
      "Scarlet Spur": { tag: "हिमाचल · सितंबर", desc: "रेड डिलिशस के पौधे से चयनित — चमकीली लालिमा वाली त्वचा और मीठा सफेद गूदा।" },
      Alphonso: { tag: "प्रीमियम · अप्रैल–जून", desc: "भारत का सबसे प्रसिद्ध आम — केसरिया गूदा, समृद्ध सुगंध और ऐसा स्वाद जो प्रीमियम निर्यात मांग को परिभाषित करता है।" },
      Kesar: { tag: "GI-टैग · गुजरात", desc: "गुजरात के जूनागढ़ / गीर सोमनाथ क्षेत्र से GI-टैग — चमकीला नारंगी गूदा और विशिष्ट सुगंध।" },
      Banganapalli: { tag: "GI-टैग · आंध्र", desc: "आंध्र प्रदेश से GI-टैग — बड़ा, रेशे रहित, मीठा फल, मजबूत शेल्फ-लाइफ।" },
      Totapuri: { tag: "कर्नाटक और आंध्र", desc: "खट्टा और सख्त, विशिष्ट चोंच आकार — कर्नाटक और आंध्र प्रदेश में व्यापक रूप से उगाया जाता है।" },
      Himsagar: { tag: "मालदा · पश्चिम बंगाल", desc: "पश्चिम बंगाल की मालदा / मुर्शिदाबाद पेटी की सुगंधित, रेशे रहित किस्म — समृद्ध और क्रीमी।" },
      Langra: { tag: "मालदा · पश्चिम बंगाल", desc: "मालदा / मुर्शिदाबाद पेटी की देर से पकने वाली, सुगंधित हरी त्वचा वाली किस्म।" },
    },
    rootstocks: {
      M9: { traits: "मानक पेड़ के ~30–35% आकार का, जल्दी फलने वाला, बहुत अधिक उपज। तार-सहारा आवश्यक।", fit: "सिंचित, उपजाऊ मिट्टी पर हाई-डेंसिटी रोपण।" },
      M26: { traits: "मानक आकार का ~40–50%, जल्दी फलने वाला और उत्पादक, अच्छा रोग प्रतिरोध।", fit: "मध्यम-से-उच्च घनत्व वाले बाग।" },
      M7: { traits: "स्थापित होने पर मध्यम उत्पादक।", fit: "मध्यम-से-निम्न घनत्व रोपण।" },
      MM106: { traits: "मजबूत और व्यापक रूप से अनुकूलनीय, अच्छी स्थिरता, जड़ रोगों के प्रति प्रतिरोधी।", fit: "मध्यम घनत्व (650–800 पेड़/हेक्टेयर) पर हिमाचल व कश्मीर की पारंपरिक व्यवस्था।" },
      MM111: { traits: "अत्यंत सूखा-सहिष्णु, फैलती जड़ें, वुली एपल एफिड प्रतिरोधी; फायर ब्लाइट और क्राउन/जड़ सड़न सहनशील।", fit: "सूखा-ग्रस्त पहाड़ी इलाके।" },
      "EMLA-9": { traits: "भरोसेमंद प्रदर्शन के लिए वायरस-जाँचित M9 चयन।", fit: "सिंचित, गहरी मिट्टी पर हाई-डेंसिटी रोपण।" },
      "EMLA-111": { traits: "वायरस-जाँचित MM111 चयन।", fit: "सूखा-ग्रस्त क्षेत्र।" },
      "EMLA-106": { traits: "वायरस-जाँचित MM106 चयन।", fit: "ढलुआँ, कम चिकनी मिट्टी।" },
      "EMLA-7": { traits: "वायरस-जाँचित M7 चयन।", fit: "ढलान वाली भूमि।" },
      "B9 (Bud 9)": { traits: "M9 जैसा आकार, उल्लेखनीय रूप से अधिक ठंड सहनशीलता।", fit: "हिमाचल व कश्मीर के ऊँचे बाग ब्लॉक।" },
      B118: { traits: "अत्यंत शीत-सहिष्णु, जल्दी फलने वाला और अत्यधिक उत्पादक; कॉलर और जड़ सड़न प्रतिरोधी।", fit: "विविध मिट्टी वाले ठंडे स्थान।" },
      G11: { traits: "M9 आकार वर्ग, मजबूत रोग प्रतिरोध।", fit: "हाई-डेंसिटी, रोग-दबाव वाले स्थान।" },
      G41: { traits: "पुनः-रोपण रोग, फायर ब्लाइट और वुली एपल एफिड के प्रति मजबूत प्रतिरोध।", fit: "विभिन्न मिट्टियों में अच्छा प्रदर्शन।" },
      G935: { traits: "M26 से थोड़ा बड़ा, अत्यधिक जल्दी फलने वाला और उत्पादक, उत्कृष्ट फल आकार।", fit: "उत्पादक मध्यम-घनत्व बाग।" },
      G214: { traits: "मध्यम शक्ति, मजबूत उपज और विकास प्रदर्शन।", fit: "बौने विकल्पों से अधिक शक्ति चाहने वाले किसान।" },
      G969: { traits: "मध्यम शक्ति, मजबूत उपज और विकास प्रदर्शन।", fit: "बौने विकल्पों से अधिक शक्ति चाहने वाले किसान।" },
    },
    articles: {
      "himachal-apple-season-outlook": {
        title: "हिमाचल सेब सीज़न का पूर्वानुमान: खरीदारों को क्या जानना चाहिए",
        excerpt: "अगस्त में गाला से लेकर अक्टूबर में फूजी तक, हिमाचल की कटाई का कैलेंडर पूरे सीज़न में उपलब्धता, कीमत और गुणवत्ता तय करता है।",
        readTime: "5 मिनट में पढ़ें",
        body: [
          { h: "ऊँचाई के साथ बदलता सीज़न", p: "हिमाचल की सेब कटाई लहरों में आती है। अगस्त में रॉयल गाला अग्रणी रहता है, सितंबर में डिलिशस समूह (रॉयल, रेड और स्कारलेट स्पर) चरम पर होता है, और अक्टूबर में फूजी और ग्रैनी स्मिथ जैसी सख्त किस्में सीज़न का समापन करती हैं। किन्नौर के ऊँचे बाग बाद में पकते हैं और असाधारण क्रंच देते हैं।" },
          { h: "खरीदारों के लिए समय क्यों मायने रखता है", p: "कैलेंडर जानने से खरीदार मात्रा और कीमत की योजना बना सकते हैं। शुरुआती गाला को ताज़गी का प्रीमियम मिलता है; सितंबर की डिलिशस चरम अवधि मात्रा और रंग का सर्वोत्तम संतुलन देती है; देर सीज़न का फूजी उन खरीदारों के लिए उपयुक्त है जिन्हें दूर के बाज़ारों के लिए लंबा शेल्फ-लाइफ चाहिए।" },
          { h: "फ़ार्मसंस कैसे सोर्स करती है", p: "हम शिमला, कुल्लू, किन्नौर और मंडी में खेत के द्वार से खरीदते हैं, हर लॉट को नाम वाले किसान से जोड़ते हैं, और खरीदार के विनिर्देश के अनुसार ग्रेड करते हैं — ताकि जो फल भेजा जाए वह ठीक वही हो जो मँगाया गया था।" },
        ],
      },
      "choosing-apple-rootstock-himachal-kashmir": {
        title: "हिमाचल और कश्मीर के लिए सही सेब रूटस्टॉक चुनना",
        excerpt: "रूटस्टॉक तय करता है पेड़ का आकार, बाग कितनी जल्दी फल देगा, और स्थानीय मिट्टी व जलवायु का सामना कैसे करेगा। चुनने का तरीका जानें।",
        readTime: "6 मिनट में पढ़ें",
        body: [
          { h: "रूटस्टॉक नींव है", p: "सेब का पेड़ रूटस्टॉक पर ग्राफ्ट की गई फलदार किस्म है। रूटस्टॉक शक्ति (पेड़ का आकार), जल्दबाज़ी (कितनी जल्दी फल), रोग प्रतिरोध और मिट्टी सहनशीलता नियंत्रित करता है — रोपण का सबसे बड़ा निर्णय।" },
          { h: "स्थान से स्टॉक का मिलान", p: "M9, B9 और G41 जैसे बौने स्टॉक सिंचित हाई-डेंसिटी बागों के लिए उपयुक्त हैं; B9 ऊँचाई पर ठंड सहनशीलता जोड़ता है। मजबूत MM111 सूखा-ग्रस्त पहाड़ियों को संभालता है। MM106 हिमाचल और कश्मीर में मध्यम-घनत्व का भरोसेमंद विकल्प बना रहता है।" },
          { h: "साझेदार, सिर्फ आपूर्तिकर्ता नहीं", p: "फ़ार्मसंस किसानों को मिट्टी, किस्म और लक्ष्य के अनुसार रूटस्टॉक चुनने में मदद करती है — प्रमाणित, वायरस-जाँचित सामग्री और कृषि मार्गदर्शन बाग तक पहुँचाती है।" },
        ],
      },
      "indian-mango-export-varieties": {
        title: "भारत के निर्यात आम: अल्फांसो, केसर और आगे",
        excerpt: "भारत की प्रीमियम आम निर्यात मांग चलाने वाली किस्मों की गाइड — और उनके पीछे के क्षेत्र व मौसम।",
        readTime: "4 मिनट में पढ़ें",
        body: [
          { h: "प्रमुख किस्में", p: "अल्फांसो सुगंध और स्वाद में अग्रणी है, केसर (GI-टैग, गुजरात) चमकीला रंग लाती है, और बंगनपल्ली (GI-टैग, आंध्र) बड़ा, रेशे रहित, लंबे शेल्फ-लाइफ वाला फल देती है। तोतापुरी खट्टी मात्रा जोड़ती है, जबकि हिमसागर और लंगड़ा बंगाल की मालदा पेटी की खुशबू ले जाते हैं।" },
          { h: "सीज़न और बाज़ार", p: "चरम सीज़न अप्रैल से जून तक चलता है। प्रीमियम मांग UAE, UK, USA और कनाडा में केंद्रित है, जहाँ ट्रेसेबल सोर्सिंग और निर्यात-ग्रेड हैंडलिंग पूर्व-शर्तें हैं।" },
          { h: "निर्यात के लिए निर्मित", p: "फ़ार्मसंस ट्रेसेबल सोर्सिंग और निर्यात-ग्रेड ग्रेडिंग से समर्थित मार्ग बना रही है ताकि प्रीमियम भारतीय आम समान स्थिति में पहुँचे।" },
        ],
      },
      "apple-import-origins-compared": {
        title: "सेब आयात स्रोतों की तुलना: आठ देश, एक आपूर्ति शृंखला",
        excerpt: "तुर्की, ईरान, इटली, पोलैंड, चिली, दक्षिण अफ्रीका, न्यूज़ीलैंड और USA — हर देश भारत के सेब आयात कैलेंडर में एक अलग खिड़की भरता है। तुलना इस प्रकार है।",
        readTime: "6 मिनट में पढ़ें",
        body: [
          { h: "भारत सेब आयात क्यों करता है", p: "हिमाचल और कश्मीर का देसी फल मौसमी है। आयात खाई भरता है — साल भर उपलब्धता बढ़ाता है, स्थानीय बागों में न मिलने वाली किस्में और आकार जोड़ता है, और देसी स्टॉक घटने पर प्रीमियम रिटेल मांग पूरी करता है।" },
          { h: "उत्तरी गोलार्ध के स्रोत", p: "तुर्की, ईरान, इटली और पोलैंड अपनी शरद कटाई के दौरान और ठीक बाद भेजते हैं। इटली और पोलैंड समान ग्रेडिंग और कोल्ड-स्टोर कार्यक्रमों के लिए जाने जाते हैं जो नए साल तक आपूर्ति करते हैं; तुर्की और ईरान प्रतिस्पर्धी, क्षेत्रीय रूप से नज़दीक मात्रा देते हैं।" },
          { h: "दक्षिणी गोलार्ध के स्रोत", p: "चिली, दक्षिण अफ्रीका और न्यूज़ीलैंड उल्टे कैलेंडर पर कटाई करते हैं, उत्तरी स्टॉक पुराने होने पर पहुँचते हैं — भारत के कमज़ोर महीनों में ताज़े, सख्त फल बहाए रखते हैं। न्यूज़ीलैंड और चिली खाने की गुणवत्ता और भरोसेमंद निर्यात प्रोटोकॉल के लिए प्रिय हैं।" },
          { h: "संयुक्त राज्य अमेरिका", p: "अमेरिकी सेब (विशेषकर वाशिंगटन राज्य) मान्यता प्राप्त प्रीमियम किस्में और सख्त ग्रेडिंग लाते हैं, बाज़ार के शीर्ष स्तर की सेवा करते हैं।" },
          { h: "फ़ार्मसंस कैसे प्रबंधन करती है", p: "हम सभी आठ स्रोतों से भारतीय बाज़ार में सोर्सिंग, दस्तावेज़ीकरण और कोल्ड-चेन का समन्वय करते हैं — ताकि खरीदारों को एक जवाबदेह साझेदार से समान गुणवत्ता और साल भर आपूर्ति मिले।" },
        ],
      },
    },
  },
};
